import '.d{display:flex;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ds{background:var(--palette-white);}.ssr-plugin'
import '.ai{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ag{max-width:77.5rem;}.ssr-plugin'
import '.f4{justify-content:stretch;}.ssr-plugin'
import '.bc{position:sticky;}.ssr-plugin'
import '.bd{top:0px;}.ssr-plugin'
import '.bh{z-index:10;}.ssr-plugin'
import '.fe{padding-block:1rem;}.ssr-plugin'
import '.ff{height:3rem;}.ssr-plugin'
import '.bm{justify-content:space-between;}.ssr-plugin'
import '.bo{flex-wrap:wrap;}.ssr-plugin'
import '.fg{margin-bottom:0px;}.ssr-plugin'
import '.fh{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ed{margin-top:2rem;}.ssr-plugin'
import '.fi{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d a8 ab e ds"
      >
        <div className="ai d r ab e"
        >
          <div className="ag d e f4 bc bd bh ds"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fe ff d bm r bo"
            >
              <styled.span className="fg"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fh d e a8 ed fi ag"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
